import emptyState from '../../../../../../assets/image/no-results.svg';
import styles from './styles.module.scss';

export const EmptyState = () => (
  <div className={styles.emptyContent}>
    <div className={styles.textWrapper}>
      <h6 className={styles.title}>Sem dados para essa seleção</h6>
      <p className={styles.subtitle}>Revise os filtros e tente novamente</p>
    </div>
    <img src={emptyState} alt="Sem dados" className={styles.image} />
  </div>
);
